import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import StepsIndicatorContainer from './Indicator/StepsIndicatorContainer.jsx';

import './StepLayout.scss';

export default class StepLayout extends PureComponent {
  static propTypes = {
    currentStep: PropTypes.number,
    helmet: PropTypes.element,
    steps: PropTypes.array,
    title: PropTypes.string.isRequired,
  };

  static defaultProps = {
    currentStep: 0,
    helmet: null,
    steps: [],
  };

  render() {
    const {currentStep, helmet, steps, ...props} = this.props;

    return <div className="step-layout d-flex flex-column justify-content-between">
      {helmet}
      <header>
        <h1 className="bg-secondary text-white text-center py-3 mb-0">{props.title}</h1>
        <StepsIndicatorContainer currentStep={currentStep} steps={steps}/>
      </header>
      <main className="bg-light d-flex align-items-center flex-grow-1 py-4 py-md-5">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8 offset-lg-2">
              <div className="form-container bg-white p-3 p-md-5">
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
  }
}